module.exports = __webpack_public_path__ + "img/img_baby_app_1_en.e8284ef7.png";